import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import { match } from 'utils/pattern-match-util'
import { JobProgressionFlow } from 'jobs/progression/JobProgression'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'
import RequestDraftReturnText from '../RequestDraftReturnText'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function JobStartedProgressionActions({ vm }: Props) {
  return match(vm.currentProgressionFlow, {
    [JobProgressionFlow.OUTSOURCING]: () => (
      <RetailOutsourcingActions vm={vm} />
    ),
    [JobProgressionFlow.RETAIL]: () => <RetailOutsourcingActions vm={vm} />,
    [JobProgressionFlow.ESSENTIAL]: () => <EssentialActions vm={vm} />,
    [JobProgressionFlow.PREPARATION]: () => <PreparationActions vm={vm} />,
    [JobProgressionFlow.REVIEW]: () => <RetailOutsourcingActions vm={vm} />,
    [JobProgressionFlow.NONE]: () => null,
    [JobProgressionFlow.PERSONAL_EXTENSION]: () => null,
    [JobProgressionFlow.BUSINESS_EXTENSION]: () => null,
    [JobProgressionFlow.OUTSOURCING_EXTENSION]: () => null,
  })
})

const RetailOutsourcingActions = observer(({ vm }: Props) => {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          type="secondary"
          size="wide-slim"
          onClick={vm.openItemsDialogVM.show}
          dataTest="job-progression-set-open-items-button"
        >
          Report Open Items
        </Button>
      </CardContent>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          disabled={vm.hasDraftReturn && !vm.isDraftReturnDownloadable}
          onClick={() => vm.answerDraftInReview()}
          dataTest="job-progression-set-draft-in-review-button"
        >
          <RequestDraftReturnText
            hasDraftReturn={vm.hasDraftReturn}
            isDraftReturnDownloadable={vm.isDraftReturnDownloadable}
            currentProgressionFlow={vm.currentProgressionFlow}
          />
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})

const EssentialActions = ({ vm }: Props) => {
  return (
    <CardContent>
      <Button
        type="primary"
        size="wide-slim"
        onClick={() => vm.viewReturnFiledDocumentCreationModal()}
        dataTest={`job-progression-${vm.currentProgressionFlow}-close-job-button`}
      >
        Upload Documents
      </Button>
    </CardContent>
  )
}

const PreparationActions = ({ vm }: Props) => {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          type="secondary"
          size="wide-slim"
          onClick={vm.openItemsDialogVM.show}
          dataTest="job-progression-set-open-items-button"
        >
          Report Open Items
        </Button>
      </CardContent>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.viewReturnFiledDocumentCreationModal()}
          dataTest="job-progression-set-upload-notes-button"
        >
          Preparation Completed
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
}
